import $ from "jquery";

class SendEmail {
  // 1.- Describe and create/initate our object
  constructor() {
    this.inputName = $("#Name");
    this.inputEmail = $("#Email");
    this.inputPhone = $("#Phone");
    this.inputMessage = $("#Message");
    // this.inputpassword = $("#Password");
    // this.inputconfirmpassword = $("#ConfirmPassword");
    this.sendMessage = $("#SendMessage");
    this.urlRegister =
      "https://signup.supportedpatient.com/#/account-information?sitecode=IBDSF";
    this.urlSignUp = "https://test.supportedpatient.com/#/signin/";
    // this.urlRegister = "http://test.supportedpatient.com/api/account/register";
    // this.urlValidateSiteCode = "http://test.supportedpatient.com/api/sites/validatesitecode/?siteCode=";

    this.SiteCode = "MReiss";
    this.siteId;
    // this.responseServerMsg = $("#responseServerMsg");

    this.pageId = $("#pageID");

    //For Patients
    this.inputFirstNameP = $("#FirstNameP");
    this.inputLastNameP = $("#LastNameP");

    //Math Recaptcha
    this.fNum = this.getRandomNum();
    this.sNum = this.getRandomNum();
    this.uiTotal = $("#uiTotal");
    this.total = this.fNum + this.sNum;

    this.fNumSpan = $("#fNumSpan");
    this.sNumSpan = $("#sNumSpan");
    this.operator = $("#operator");

    this.SetUpUI();

    this.events();
  }

  // 2.- events
  events() {
    this.sendMessage.on("click", this.sendEmail.bind(this));
  }

  // 3.- methods (function, action...)
  getRandomNum() {
    return Math.floor(Math.random() * 10 + 1);
  }

  SetUpUI() {
    this.fNumSpan.html(this.fNum);
    this.sNumSpan.html(this.sNum);
    this.operator.html("+");
  }

  sendEmail() {
    var name = this.inputName.val();
    var fname = this.inputFirstNameP.val();
    var lname = this.inputLastNameP.val();
    var email = this.inputEmail.val();
    var phone = this.inputPhone.val();
    // var password = this.inputpassword.val();
    // var confirmPassword = this.inputconfirmpassword.val();
    var message = this.inputMessage.val();

    var pageId = this.pageId.val();
    var url = "";

    var division = "";

    switch (pageId) {
      case "48":
      case "72":
      case "84":
        //division = "-(ALLIED HEALTHCARE PROFESSIONALS)->";
        division = "ALLIED";
        url = "https://apihelper.supportedpatient.com/Email/Send";
        //url = "http://localhost:25782/Email/Send";

        break;
      case "62":
        //division = "-(PAYERS, PROVIDERS & PRACTICE MANAGERS)-";
        division = "PAYERS";
        url = "https://apihelper.supportedpatient.com/Email/Send";
        //url = "http://localhost:25782/Email/Send";
        break;
      default:
        division = "-(PATIENTS)-";
        url = "https://apihelper.supportedpatient.com/Email/Sendpat";
        break;
    }

    var data = {
      division: division,
      name: name,
      firstname: fname,
      lastname: lname,
      email: email,
      phone: phone,
      message: message,
      /*password: password,
      confirmPassword: confirmPassword,
      siteId: ""*/
    };

    switch (pageId) {
      case "48":
      case "62":
      case "72":
      case "84":
        if (
          name !== "" &&
          email !== "" &&
          phone !== "" &&
          message !== "" &&
          this.total == parseInt(this.uiTotal.val())
        ) {
          this.highlightErrors(true);
          $("#SendMessage").prop("disabled", true);
          $(".message-form").text(
            window.location.hash == "#he"
              ? "אנא המתן המידע נשלח."
              : "Please wait the information is being sent."
          );

          $.ajax({
            type: "POST",
            url: url,
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            data: JSON.stringify(data),
            success: (response) => {
              $("#salesForm")[0].reset();
              $("#submit_form").prop("disabled", false);
              $(".message-form").text("");
              //grecaptcha.reset();
              if (response.result == "success") {
                alert(
                  window.location.hash == "#he"
                    ? "המידע נשלח בהצלחה!"
                    : "The information has been sent successfully!"
                );
              } else {
                alert(
                  window.location.hash == "#he"
                    ? "אירעה שגיאה בעת ניסיון לשלוח את האימייל: =>"
                    : "An error happened while trying to send the email: => " +
                        response.exception
                );
              }
            },
          });
        } else {
          this.highlightErrors(false);
          alert(
            window.location.hash == "#he"
              ? "נא להזין את כל השדות הנדרשים כראוי!"
              : "Please enter all required fields properly !"
          );
        }
        break;

      case "45":
        if (this.total == parseInt(this.uiTotal.val())) {
          this.highlightErrors(true);
          $("#SendMessage").prop("disabled", true);
          //$(".message-form").text("Please wait the information is being sent.");

          //var urlReg = this.urlRegister;

          // $.get( this.urlValidateSiteCode + this.SiteCode)
          //     .done(function( site_id ) {

          //  });

          window.location = this.urlRegister;
        } else {
          this.highlightErrors(false);
          alert(
            window.location.hash == "#he"
              ? "נא להזין את כל השדות הנדרשים כראוי!"
              : "Please enter all required fields properly !"
          );
        }
        break;
    }
  }

  getSiteId(siteCode) {
    $.get(this.urlValidateSiteCode + siteCode, function (data) {
      return data;
    });
  }

  highlightErrors(resetForm) {
    switch (this.pageId.val()) {
      case "48":
      case "62":
      case "72":
      case "84":
        if (resetForm) {
          this.inputName.css("background-color", "white");
          this.inputEmail.css("background-color", "white");
          this.inputPhone.css("background-color", "white");
          this.uiTotal.css("background-color", "white");
          break;
        }
        //-(PAYERS, PROVIDERS & PRACTICE MANAGERS)-
        if (this.inputName.val() == "") {
          this.inputName.css("background-color", "orange");
        } else {
          this.inputName.css("background-color", "white");
        }

        if (this.inputEmail.val() == "") {
          this.inputEmail.css("background-color", "orange");
        } else {
          this.inputEmail.css("background-color", "white");
        }

        if (this.inputPhone.val() == "") {
          this.inputPhone.css("background-color", "orange");
        } else {
          this.inputPhone.css("background-color", "white");
        }

        if (this.total != parseInt(this.uiTotal.val())) {
          this.uiTotal.css("background-color", "orange");
        } else {
          this.uiTotal.css("background-color", "white");
        }
        break;
      default:
        //-(PATIENTS)-
        if (resetForm) {
          // this.inputFirstNameP.css("background-color", "white");
          // this.inputLastNameP.css("background-color", "white");
          this.uiTotal.css("background-color", "white");
          // this.inputpassword.css("background-color", "white");
          // this.inputconfirmpassword.css("background-color", "white");
          break;
        }

        // if(this.inputFirstNameP.val() == ""){
        //   this.inputFirstNameP.css("background-color", "orange");
        // }else{
        //   this.inputFirstNameP.css("background-color", "white");
        // }

        // if(this.inputLastNameP.val() == ""){
        //   this.inputLastNameP.css("background-color", "orange");
        // }else{
        //   this.inputLastNameP.css("background-color", "white");
        // }

        // if(this.inputEmail.val() == ""){
        //   this.inputEmail.css("background-color", "orange");
        // }else{
        //   this.inputEmail.css("background-color", "white");
        // }

        if (this.total != parseInt(this.uiTotal.val())) {
          this.uiTotal.css("background-color", "orange");
        } else {
          this.uiTotal.css("background-color", "white");
        }

        // if(this.inputpassword.val().trim() != this.inputconfirmpassword.val().trim()){
        //   this.inputpassword.css("background-color", "orange");
        //   this.inputconfirmpassword.css("background-color", "orange");
        // }else{
        //   this.inputpassword.css("background-color", "white");
        //   this.inputconfirmpassword.css("background-color", "white");
        // }

        break;
    }
  }
}

export default SendEmail;
